<template>
	<van-overlay class="subscribe_dialog" :show="visible">
		<div class="subscribe_dialog__main">
			<div class="subscribe_dialog__main__body bg-white">
				<div class="header">
					<h2 class="title">咨询通知</h2>
				</div>
				<p class="message"
					>您预约的{{detail.doctorName}}医生的{{detail.serviceName}}时间已到，请及时进入咨询室进行咨询</p
				>
				<div class="handle">
					<open-ssl :username="$config.sslAppid" :path="`${ $config.sslPath }?consultId=${detail.targetId}`">
						<van-button type="primary" block round @click="visible=false">进入咨询室</van-button>
					</open-ssl>
				</div>
			</div>
			<div class="subscribe_dialog__main__close text-center">
				<img class="icon_close" src="@/assets/icon/icon_close_circle.png" @click="visible = false" />
			</div>
		</div>
	</van-overlay>
</template>

<script>
export default {
    name: 'home-subscribe-dialog',
    data: () => ({
        visible: false,
        detail: {}
    }),
    methods: {
        init (item) {
            this.visible = true
            this.detail = item
        }
    }
};
</script>
<style scoped lang="less">
.subscribe_dialog {
	box-sizing: border-box;
	padding-left: 30px;
	padding-right: 30px;
}
</style>
